/**
 * Standard pattern for running a graphql async mutation and updating component
 * state in response to mutation events. Also handles errors in a standard way.
 *
 * @param [Object] component the instance of the component that is invoking the
 * mutation.
 * @param [Function] mutate a function that executes a mutation call. Must
 * return a promise.
 * @return [Promise] a promise to observe the mutation call.
 */
export default function runMutation(component, mutate) {
  component.setState({
    submitting: true,
    mutationError: null,
    mutationErrors: null,
  })

  return mutate()
    .then(result => ({ result }))
    .catch(error => {
      const mutationErrors =
        error.graphQLErrors && error.graphQLErrors.filter(e => !e.validationErrors)

      component.setState({
        mutationError: error,
        mutationErrors: mutationErrors && mutationErrors.length > 0 ? mutationErrors : null,
      })

      return { error }
    })
    .then(args => {
      component.setState({ submitting: false })
      return args
    })
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/runMutation.js